import type { ValueOf } from '../util/typeUtils';

export const CHAT_READ_CURSOR_COMMANDS = {
    markChatViewed: 'markChatViewed',
} as const;

export type CHAT_READ_CURSOR_COMMAND = ValueOf<typeof CHAT_READ_CURSOR_COMMANDS>;
